import script from "./budget-actions-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-actions-select.vue?vue&type=script&setup=true&lang=ts"

import "./budget-actions-select.vue?vue&type=style&index=0&id=b75df6b2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75df6b2"]])

export default __exports__